import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const services = [
  {
    category: 'Security Personnel',
    items: [
      {
        icon: 'ri-shield-user-line',
        title: 'Uniformed Security Officers',
        description: 'Professional uniformed security officers providing visible deterrence and comprehensive protection for your property and assets.',
      },
      {
        icon: 'ri-ship-line',
        title: 'Maritime Operations',
        description: 'Specialized maritime security services for ports, cruise ships, and waterfront facilities with trained personnel.',
      },
      {
        icon: 'ri-car-line',
        title: 'Mobile Patrol',
        description: 'Rapid response mobile patrol units providing comprehensive coverage across multiple locations and properties.',
      },
      {
        icon: 'ri-police-badge-line',
        title: 'Off Duty Police Officers',
        description: 'Experienced off-duty law enforcement officers available for enhanced security and emergency response capabilities.',
      },
      {
        icon: 'ri-calendar-event-line',
        title: 'Special Event Security',
        description: 'Comprehensive event security planning and execution for gatherings of all sizes, ensuring safe and successful events.',
      },
      {
        icon: 'ri-walk-line',
        title: 'Crossing Guards',
        description: 'Trained crossing guards ensuring the safety of pedestrians and students at designated crossing locations.',
      },
    ],
  },
  {
    category: 'Surveillance & Technology',
    items: [
      {
        icon: 'ri-search-eye-line',
        title: 'Investigations & Consulting',
        description: 'Professional investigation services and security consulting to identify vulnerabilities and develop comprehensive protection strategies.',
      },
      {
        icon: 'ri-camera-line',
        title: 'Video Surveillance',
        description: 'Advanced video surveillance systems with 24/7 monitoring capabilities for comprehensive property protection.',
      },
      {
        icon: 'ri-user-search-line',
        title: 'Facial Recognition Integration',
        description: 'Cutting-edge facial recognition technology integration for enhanced access control and threat identification.',
      },
    ],
  },
  {
    category: 'Business Protection',
    items: [
      {
        icon: 'ri-shield-check-line',
        title: 'Risk Management',
        description: 'Comprehensive risk assessment and management services to identify, evaluate, and mitigate security threats.',
      },
      {
        icon: 'ri-alert-line',
        title: 'Loss Prevention',
        description: 'Strategic loss prevention programs designed to minimize theft, fraud, and operational losses in retail and commercial environments.',
      },
    ],
  },
];

const ServicesPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <section className="relative pt-32 pb-20 bg-dark-900">
        <div className="absolute inset-0">
          <img
            src="https://cdn.prod.website-files.com/68b07a689aa678cd7b4261c6/68c47978c3083941a17ca9bc_p6.avif"
            alt="Security Services"
            className="w-full h-full object-cover opacity-20"
          />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 font-display">
            Comprehensive Security Services
          </h1>
          <p className="text-xl text-dark-100 max-w-3xl mx-auto">
            Professional security solutions tailored to your specific needs, delivered by highly trained personnel with years of industry expertise.
          </p>
        </div>
      </section>

      {services.map((section, sectionIndex) => (
        <section key={sectionIndex} className={`py-20 ${sectionIndex % 2 === 0 ? 'bg-white' : 'bg-dark-50'}`}>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl md:text-4xl font-bold text-dark-900 mb-12 font-display text-center">
              {section.category}
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {section.items.map((service, index) => (
                <div
                  key={index}
                  className="bg-white border border-dark-200 rounded-lg p-8 hover:border-primary-500 hover:shadow-lg transition-all hover:transform hover:scale-105 cursor-pointer group"
                >
                  <div className="w-14 h-14 flex items-center justify-center bg-primary-500/10 rounded-lg mb-6 group-hover:bg-primary-500 transition-colors">
                    <i className={`${service.icon} text-3xl text-primary-600 group-hover:text-white`}></i>
                  </div>
                  <h3 className="text-xl font-semibold text-dark-900 mb-3">{service.title}</h3>
                  <p className="text-dark-600 text-sm leading-relaxed">{service.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      ))}

      <section className="py-20 bg-primary-500">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-dark-900 mb-6 font-display">
            Need a Custom Security Solution?
          </h2>
          <p className="text-lg text-dark-800 mb-8">
            Every security challenge is unique. Let us create a tailored solution that meets your specific requirements and budget.
          </p>
          <a
            href="/contact"
            className="inline-flex items-center px-8 py-4 bg-dark-900 text-white rounded-lg text-base font-semibold hover:bg-dark-800 transition-colors whitespace-nowrap cursor-pointer"
          >
            Request a Free Consultation
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ServicesPage;